<div class="container">
  <nx-message context="error">
    {{ 'An error occurred' | transloco }}<br />
    {{ 'It seems something went wrong on our end.' | transloco }}
  </nx-message>
</div>
